import React, { useMemo } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const TOOLBAR = [
  [{ header: [2, 3, false] }],
  ['bold', 'italic', 'underline'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  ['clean'],
];

/**
 * Rich text field backed by react-quill.
 * Stores and receives HTML strings.
 */
const EditorField = ({ value, onChange, placeholder }) => {
  const modules = useMemo(() => ({ toolbar: TOOLBAR }), []);

  return (
    <ReactQuill
      className="admin-editorjs-field"
      theme="snow"
      value={value || ''}
      onChange={onChange}
      modules={modules}
      placeholder={placeholder || 'Enter content...'}
    />
  );
};

export default EditorField;
